import { useSelector } from "react-redux"

import { cn } from "styles/utils"

const Badge = () => {
  const badgeLabel = useSelector(
    (state) =>
      state.wizard.badge?.label ??
      (state.wizard.price_and_promo?.on_sale && "Sale")
  )
  const currentSlideIndex = useSelector(
    (state) => state.previewImage.slideIndex
  )

  if (!badgeLabel) return null

  return (
    <div
      className={cn(
        "bg-light-pink text-black-print h-18 text-12 flex items-center justify-center px-12 font-semibold transition-opacity",
        currentSlideIndex === 0 ? "" : "opacity-0"
      )}
    >
      {badgeLabel}
    </div>
  )
}

export default Badge
